import { HttpClient, HttpHeaders } from '@angular/common/http';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { EventEmitter, Inject, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Observable, of, Subject } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { MsalService } from '@azure/msal-angular';
import { environment } from "../../environments/environment";
@Injectable({ providedIn: 'root' })
export class SystemService {
  reloadHeader = new EventEmitter();
  private environmentService = inject(EnvironmentService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  user: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  user_dev: any = {
    name: 'dev',
    email: 'test@test.com',
    // eslint-disable-next-line sonarjs/no-duplicate-string
    password: 'Password12!',
    adminApiUrl: 'https://development-api-enrollment.azure-api.net',
    subscriptionKey: 'edf6d0cd728844e79d9a8dab9e75e7a6',
    accountId: 'xj7yhns98z1',
    // eslint-disable-next-line sonarjs/no-duplicate-string
    applicantId: 'ebe9b75e-6b02-4d89-835d-11e42c3a1111',
    // eslint-disable-next-line sonarjs/no-duplicate-string
    senderId: 'f456b942-4377-40be-9fbc-bfef9e306a42'
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  user_test: any = {
    name: 'testing',
    email: 'test@test.com',
    password: 'Password12!',
    adminApiUrl: 'https://testing-api-enrollment.azure-api.net',
    subscriptionKey: '95cb3443f3554755880f0a40a7ad10e7',
    accountId: 'mytoken',
    applicantId: 'ebe9b75e-6b02-4d89-835d-11e42c3a1111',
    senderId: 'f456b942-4377-40be-9fbc-bfef9e306a42'
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  user_local: any = {
    name: 'local',
    email: 'test@local.com',
    password: 'Password12!',
    adminApiUrl: this.environmentService.adminApiUrl,
    subscriptionKey: this.environmentService.subscriptionKey,
    accountId: 'mytoken',
    applicantId: 'ebe9b75e-6b02-4d89-835d-11e42c3a1111',
    senderId: 'f456b942-4377-40be-9fbc-bfef9e306a42'
  };

  headers = new HttpHeaders({
    'Ocp-Apim-Subscription-Key': 'edf6d0cd728844e79d9a8dab9e75e7a6',
    'Content-Type': 'application/json'
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  demoData: any[] = [
    {
      status: 'Needs Attention',
      name: 'Update Credentials',
      desc: "1 employee credentials couldn't be validated",
      date: '11/03/2024'
    },
    { status: 'Updated', name: 'Update NPI#', desc: 'Update NPI#', date: '11/03/2024' }
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  basicData: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  basicOptions: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  systemData: any;

  constructor(
    // eslint-disable-next-line @angular-eslint/prefer-inject
    private http: HttpClient,
    // eslint-disable-next-line @angular-eslint/prefer-inject
    private router: Router,
    // eslint-disable-next-line @angular-eslint/prefer-inject
    private msalService: MsalService
  ) {
    this.user = this.getProfile();
    this.basicData = {
      labels: ['Q1', 'Q2', 'Q3', 'Q4'],
      datasets: [
        {
          label: 'Sales',
          data: [540, 325, 702, 620],
          backgroundColor: [
            'rgba(255, 159, 64, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(153, 102, 255, 0.2)'
          ],
          borderColor: ['rgb(255, 159, 64)', 'rgb(75, 192, 192)', 'rgb(54, 162, 235)', 'rgb(153, 102, 255)'],
          borderWidth: 1
        }
      ]
    };

    this.basicOptions = {
      plugins: {
        legend: {
          labels: {
            color: '#000'
          }
        }
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            color: '#ddd'
          },
          grid: {
            color: '#bdbdbd',
            drawBorder: false
          }
        },
        x: {
          ticks: {
            color: '#ddd'
          },
          grid: {
            color: '#bdbdbd',
            drawBorder: false
          }
        }
      }
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDashboard(): Observable<any> {
    return this.http.get(
      this.user.adminApiUrl + '/partners/accounts/dashboard'
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) as Observable<any>;
  }

  isAuthenticated(): Observable<boolean> {
    // Replace this with your actual authentication logic
    const token = localStorage.getItem('token');
    return of(!!token); // Returns true if token exists, false otherwise
  }

  login(payload) {
    // Implement your login logic here
    localStorage.setItem('token', JSON.stringify(payload));
    this.user = payload;
    this.systemData = payload;
  }

  logout() {
    // Clear all roster agreement acceptances from sessionStorage
    this.clearRosterAgreementStorage();

    // Clear user groups cache
    this.clearUserGroupsCache();

    this.msalService.logoutRedirect({
      postLogoutRedirectUri: environment.appUrl,
      authority: 'https://login.microsoftonline.com/4d0b1d13-40fc-479b-870b-9f17bf4b23b6'
    });
  }

  private clearRosterAgreementStorage(): void {
    // Remove all keys that start with 'roster_agreement_accepted'
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith('roster_agreement_accepted')) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => sessionStorage.removeItem(key));
  }

  private clearUserGroupsCache(): void {
    // Remove all keys that start with 'userGroups:' (from AuthService cache)
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith('userGroups:')) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => sessionStorage.removeItem(key));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getProfile(): any {
    return JSON.parse(localStorage.getItem('token') || '{}');
  }

  loadConfig(config) {
    switch (config) {
      case 'dev':
        this.user = this.user_dev;
        break;
      case 'test':
        this.user = this.user_test;
        break;
      case 'local':
        this.user = this.user_local;
        break;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getUserProfile(): any {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.http.get(`${this.user.adminApiUrl}/personas/${this.user.applicantId}/GetProfile`) as Observable<any>;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  saveUserProfile(payload: any) {
    return this.http.put(`${this.user.adminApiUrl}/personas/SaveApplicantProfile`, payload);
  }
}
